import { render, staticRenderFns } from "./MainModeHistoryPaperList.vue?vue&type=template&id=0ddf186b&scoped=true&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeEvents/components/MainModeHistoryPaperList?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeEvents/components/MainModeHistoryPaperList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf186b",
  null
  
)

export default component.exports